import React from 'react';
import CreateComponent from '../../../components/create';
const Create = (props) => (
  <CreateComponent {...props}/>
)

export default Create; 
